module.exports = __webpack_public_path__ + "img/img_logo.62892ebf.png";